import { BaseEntity } from 'src/app/core/domain/base.entity';
import { SimNao } from '../simNao/sim-nao';

export class Status extends BaseEntity {
  descricao: string;
  detalhamento: string;
  impedeNovoSup: SimNao;
}
